<div class="container logout">
  <div class="row">
    <div class="col">
      <h1 class="page-title">
        {{ "ERROR_TEXT1" | globalTranslate }}@if (mobileUser) {
        <span class="page-title">!</span>
        }
      </h1>
    </div>
  </div>
  <div class="bg-custom">
    <div class="container manage-benefits">
      <div>
        <div class="mt-3">
          <div class="container col-xs-12 .col-12 row g-3">
            <div class="col-md-12 col-sm-12">
              <div class="py-4">
                <b>
                  {{ "ERROR_TEXT2" | globalTranslate }}
                  {{ "Time" | globalTranslate }}:
                  <span aria-hidden="true">{{
                    currentDate | date: "EEE MMM dd hh:mm:ss yyyy"
                  }}</span>
                  <span class="visually-hidden">{{
                    getAccessibleTimeLabel()
                  }}</span>
                </b>
              </div>
            </div>

            <div class="col-md-12 col-sm-12">
              <div class="py-4">
                <p [innerHTML]="'ERROR_TEXT3' | globalTranslate | sanitize"></p>
                @if (!mobileUser) {
                <br />
                } @if (!mobileUser) {
                <p>{{ "ERROR_TEXT4" | globalTranslate }}</p>
                }
              </div>
            </div>

            @if (mobileUser) {
            <div class="col-md-12 col-sm-12">
              <div class="py-2">
                <p>{{ "ERROR_TEXT6" | globalTranslate }}</p>
              </div>
            </div>
            } @if (!mobileUser) {
            <div class="col-md-12 col-sm-12">
              <div class="py-4 text-align">
                <hr />
                <div style="padding-top: 20px">
                  <a
                    class="btn-link btn-go-home"
                    (click)="gotoHome()"
                    tabindex="0"
                  >
                    {{ "ERROR_TEXT5" | globalTranslate }}</a
                  >
                </div>
              </div>
            </div>

            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
